import React from "react";

const SidebarPayment = ({ activeSection, showSection }) => {
  return (
    <div className="accounting-sidebar-container">
      {/* Desktop Navigation */}
      <nav className="accounting-desktop-nav">
        <div className="accounting-sidebar-header">
          <h2 className="accounting-sidebar-title mb-0">Account Ledger</h2>
        </div>

        <div className="accounting-sidebar-menu">
          <a
            href="#"
            onClick={() => showSection("all-transactions")}
            className={`accounting-sidebar-link ${
              activeSection === "all-transactions" ? "accounting-active" : ""
            }`}
          >
            All Transactions
          </a>

          {/* <a
            href="#"
            onClick={() => showSection("driver-ledger")}
            className={`accounting-sidebar-link ${
              activeSection === "driver-ledger" ? "accounting-active" : ""
            }`}
          >
            Driver Ledger
          </a>
          <a
            href="#"
            onClick={() => showSection("driver-day-wise")}
            className={`accounting-sidebar-link ${
              activeSection === "driver-day-wise" ? "accounting-active" : ""
            }`}
          >
            Discount & Charges
          </a> */}

          <a
            href="#"
            onClick={() => showSection("payment-entry")}
            className={`accounting-sidebar-link ${
              activeSection === "payment-entry" ? "accounting-active" : ""
            }`}
          >
            Payment Entry
          </a>

          <a
            href="#"
            onClick={() => showSection("update-charges")}
            className={`accounting-sidebar-link ${
              activeSection === "update-charges" ? "accounting-active" : ""
            }`}
          >
            Update Charges
          </a>

          <a
            href="#"
            onClick={() => showSection("add-discount")}
            className={`accounting-sidebar-link ${
              activeSection === "add-discount" ? "accounting-active" : ""
            }`}
          >
            Add Discount
          </a>
          <a
            href="#"
            onClick={() => showSection("payment-refund")}
            className={`accounting-sidebar-link ${
              activeSection === "payment-refund" ? "accounting-active" : ""
            }`}
          >
            Payment Refund
          </a>

          {/* <a
            href="#"
            onClick={() => showSection("adjustment")}
            className={`accounting-sidebar-link ${
              activeSection === "adjustment" ? "accounting-active" : ""
            }`}
          >
            Reallocation Ledger
          </a> */}

          <a
            href="#"
            onClick={() => showSection("transaction-edit")}
            className={`accounting-sidebar-link ${
              activeSection === "transaction-edit" ? "accounting-active" : ""
            }`}
          >
            Payment Reallocation
          </a>
        </div>
      </nav>
    </div>
  );
};

export default SidebarPayment;
